<script>
export default {
  install(Vue) {
    var BBUtil = function () {
      var rep = function (str, pattern, replacement) {
        return str.replace(new RegExp(pattern, "gm"), replacement);
      }
      var b = function (str) {
        return rep(str, "\\[b\\]([\\s\\S]*?)\\[/b\\]", "<b>$1</b>");
      }
      var i = function (str) {
        return rep(str, "\\[i\\]([\\s\\S]*?)\\[/i\\]", "<i>$1</i>");
      }
      var ul = function (str) {
        return rep(str, "\\[ul\\]\\s*([\\s\\S]*?)\\s*\\[/ul\\]", "<ul>$1</ul>");
      }
      var ol = function (str) {
        return rep(str, "\\[ol\\]\\s*([\\s\\S]*?)\\s*\\[/ol\\]", "<ol>$1</ol>");
      }
      var li = function (str) {
        return rep(str, "\\s*\\[li\\]\\s*([\\s\\S]*?)\\s*\\[/li\\]\\s*", "<li>$1</li>");
      }
      var url = function (str) {
        return rep(str, "\\[url\\]\\s*([\\s\\S]*?)\\s*\\[/url\\]", "<a href=\"$1\">$1</a>");
      }
      var newLines = function (str) {
        return rep(str, "\n", "<br/>");
      }
      var inline = function (str) {
        str = b(str);
        str = i(str);
        str = url(str);
        return str;
      }
      var block = function (str) {
        str = inline(str);
        str = ul(str);
        str = ol(str);
        str = li(str);
        str = newLines(str);
        return str;
      }
      return {
        inline: inline,
        block: block
      };
    };
    Vue.$bbUtil = new BBUtil()
  }
}
</script>